module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjEyNSAxLjI1SDEuODc1QzEuMTg3NSAxLjI1IDAuNjI1IDEuODEyNSAwLjYyNSAyLjVWMTBDMC42MjUgMTAuNjg3NSAxLjE4NzUgMTEuMjUgMS44NzUgMTEuMjVINi4yNVYxMi41SDVWMTMuNzVIMTBWMTIuNUg4Ljc1VjExLjI1SDEzLjEyNUMxMy44MTI1IDExLjI1IDE0LjM3NSAxMC42ODc1IDE0LjM3NSAxMFYyLjVDMTQuMzc1IDEuODEyNSAxMy44MTI1IDEuMjUgMTMuMTI1IDEuMjVaTTEzLjEyNSAxMEgxLjg3NVYyLjVIMTMuMTI1VjEwWiIgZmlsbD0iIzYwNjA2MCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-ui/web.svg
// module id = 6BJS
// module chunks = 46